export default '__sortable__'




// WEBPACK FOOTER //
// ./src/itemType.js